import {Component, Injector, OnInit} from "@angular/core";
import {VisitorService} from "../visitor/visitor.service";
import {Visitor} from "../visitor/visitor";
import {createDtoProperties, DtoComponent, Filter, mapCollection,} from "@mango/core";
import {MatSnackBar} from "@angular/material/snack-bar";
import {UnregisterDialogService} from "../unregister-dialog/unregister-dialog.service";

@Component({
  selector: "app-unregister",
  templateUrl: "./unregister.component.html",
  styleUrls: ["./unregister.component.css"],
})
export class UnregisterComponent
  extends DtoComponent<Visitor>
  implements OnInit {
  constructor(
    private visitorService: VisitorService,
    injector: Injector,
    private snackBar: MatSnackBar,
    private dialogService: UnregisterDialogService
  ) {
    super(injector, visitorService, Visitor);
  }

  selectedItem: Visitor | null = null;

  properties = createDtoProperties<Visitor>([
    "name",
    {"company": ["id"]},
    "meetingPerson",
    "totalDurationMin",
    "registerTime",
    "unregisterTime",
  ]);

  visitors: Visitor[] = [];

  visitorsLoaded: boolean = false;

  async ngOnInit(): Promise<void> {
    this.updateVisitors();
  }

  handleClick(item: Visitor) {
    this.dialogService.openDialog(item);
  }

  showSuccessMessage(message: string): void {
    this.snackBar.open(message, "Close", {
      duration: 3000,
      panelClass: ["success-snackbar"],
    });
  }

  showErrorMessage(message: string): void {
    this.snackBar.open(message, "Close", {
      duration: 3000,
      panelClass: ["error-snackbar"],
    });
  }

  async updateVisitors() {
    //This method long-term might make the app slow. (could add a filter to get method)
    this.visitors = await this.visitorService
      .get({
        properties: [
          "name",
          {"company": ["id"]},
          {"school": ["id"]},
          "other",
          "meetingPerson",
          "registerTime",
          "unregisterTime",
          "totalDurationMin",
        ],
        filter: new Filter<Visitor>((fb) => [
          fb.equal((x) => x.unregisterTime, null),
        ]),
        orderBy: [4],
      })
      .pipe(mapCollection())
      .toPromise();
    this.visitorsLoaded = true;
  }

  async deleteSelected(visitor: Visitor) {
    visitor.unregisterTime = new Date();
    visitor.registerTime = new Date(visitor.registerTime);

    visitor.totalDurationMin = Math.round((visitor.unregisterTime.getTime() - visitor.registerTime.getTime()) / (1000 * 60));

    try {
      const result = await this.dialogService.openDialog(visitor);
      if (result) {
        await this.visitorService.update(visitor).toPromise();
        this.showSuccessMessage("Succes! Bedankt voor uw bezoek!");
        this.goBack();
      }
    } catch (error) {
      console.error("Failed to delete visitor:", error);
      this.showErrorMessage("Er is iets fout gegaan. Probeer het later nog eens.");
    }
  }

  goBack() {
    this.router.navigate(["/landing"]);
  }
}
